
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { BarChart3, LineChart, PieChart } from "lucide-react";
import { useNavigate } from "react-router-dom";

export function FeatureCarousel() {
  const navigate = useNavigate();
  
  const features = [
    {
      title: "Controle Total de Receitas",
      description: "Registre e acompanhe todas as entradas financeiras em um só lugar, facilitando decisões estratégicas para o crescimento do seu negócio.",
      icon: <LineChart className="h-12 w-12 text-finance-turquoise" />,
    },
    {
      title: "Gestão de Despesas Inteligente",
      description: "Monitore gastos, estabeleça metas e identifique oportunidades de economia para maximizar a lucratividade da sua empresa.",
      icon: <BarChart3 className="h-12 w-12 text-finance-turquoise" />,
    },
    {
      title: "Relatórios Detalhados",
      description: "Visualize insights poderosos através de relatórios automatizados que ajudam a tomar decisões mais assertivas para seu negócio.",
      icon: <PieChart className="h-12 w-12 text-finance-turquoise" />,
    },
  ];

  return (
    <section className="py-20 px-6 bg-muted/50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 gradient-text">
            Simplifique a Gestão Financeira da sua Empresa
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Transforme dados em decisões inteligentes e impulsione o crescimento do seu negócio
          </p>
        </div>

        <Carousel
          opts={{
            align: "start",
            loop: true,
          }}
          className="w-full max-w-5xl mx-auto"
        >
          <CarouselContent>
            {features.map((feature, index) => (
              <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                <Card className="p-6 h-full flex flex-col items-center text-center card-hover">
                  <div className="mb-6 rounded-full bg-muted p-4">
                    {feature.icon}
                  </div>
                  <h3 className="text-xl font-semibold mb-3">{feature.title}</h3>
                  <p className="text-muted-foreground mb-6 flex-grow">
                    {feature.description}
                  </p>
                  <Button
                    onClick={() => navigate("/login?mode=register")}
                    variant="outline"
                    className="w-full"
                  >
                    Começar Agora
                  </Button>
                </Card>
              </CarouselItem>
            ))}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex" />
          <CarouselNext className="hidden md:flex" />
        </Carousel>
      </div>
    </section>
  );
}
